import { lazy } from "react";

const ListPosInvoicesPage = lazy(() => import("./main"));

export { ListPosInvoicesPage };
